module.exports = __webpack_public_path__ + "media/images/flags/mm-069b07b838df10543f81c55b9c257a1b.svg";